/**
 * Hide Usercentrics privacy button when it appears in shadow DOM
 * Monitors the #usercentrics-cmp-ui element and hides privacyButton when visible
 */
(function() {
  'use strict';

  function hidePrivacyButton() {
    const usercentricsElement = document.getElementById('usercentrics-cmp-ui');
    
    if (!usercentricsElement) {
      return false;
    }

    // Check if element has shadow root
    const shadowRoot = usercentricsElement.shadowRoot;
    if (!shadowRoot) {
      return false;
    }

    // Look for privacyButton element in shadow root
    // Try multiple possible selectors
    const privacyButton = shadowRoot.querySelector('#uc-main-dialog.privacyButton') ||
                          shadowRoot.querySelector('.privacyButton') ||
                          shadowRoot.querySelector('[id*="privacyButton"]') ||
                          shadowRoot.querySelector('[class*="privacyButton"]');

    if (privacyButton) {
      // Check if it's visible before hiding
      const style = window.getComputedStyle(privacyButton);
      if (style.display !== 'none' && style.visibility !== 'hidden') {
        privacyButton.style.display = 'none';
        privacyButton.style.visibility = 'hidden';
        return true;
      }
    }

    // Also check for direct children that might be privacyButton or cmp-wrapper
    const children = Array.from(usercentricsElement.children);
    for (const child of children) {
      if (child.id === 'privacyButton' || 
          child.classList.contains('privacyButton') ||
          child.id === 'cmp-wrapper' ||
          child.classList.contains('cmp-wrapper')) {
        // If it's privacyButton, hide it
        if (child.id === 'privacyButton' || child.classList.contains('privacyButton')) {
          const style = window.getComputedStyle(child);
          if (style.display !== 'none' && style.visibility !== 'hidden') {
            child.style.display = 'none';
            child.style.visibility = 'hidden';
            return true;
          }
        }
      }
    }

    return false;
  }

  function checkAndHide() {
    hidePrivacyButton();
  }

  // Run immediately
  checkAndHide();

  // Use MutationObserver to watch for when the element appears or changes
  const observer = new MutationObserver(function(mutations) {
    checkAndHide();
  });

  // Start observing when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      const usercentricsElement = document.getElementById('usercentrics-cmp-ui');
      if (usercentricsElement) {
        observer.observe(usercentricsElement, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class']
        });
        
        // Also observe shadow root if it exists
        if (usercentricsElement.shadowRoot) {
          observer.observe(usercentricsElement.shadowRoot, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
          });
        }
      }
    });
  } else {
    // DOM already loaded
    const usercentricsElement = document.getElementById('usercentrics-cmp-ui');
    if (usercentricsElement) {
      observer.observe(usercentricsElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
      
      if (usercentricsElement.shadowRoot) {
        observer.observe(usercentricsElement.shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class']
        });
      }
    }
  }

  // Also watch for when the element is added to the DOM
  const bodyObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.id === 'usercentrics-cmp-ui') {
            checkAndHide();
            observer.observe(node, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['style', 'class']
            });
            
            if (node.shadowRoot) {
              observer.observe(node.shadowRoot, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style', 'class']
              });
            }
          } else if (node.querySelector && node.querySelector('#usercentrics-cmp-ui')) {
            checkAndHide();
          }
        }
      });
    });
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Periodic check as fallback (in case MutationObserver misses something)
  setInterval(checkAndHide, 1000);
})();

